import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, postRequest } from '../config/axios-config';

export const getUserSettings = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getUserSettings
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const updateUserSettings = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateUserSettings,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const createCustomTag = (name) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createCustomTag,
        { name }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const removeCustomTag = (name) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.removeCustomTag,
        { name }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const enableAutoArchive = (archiveSettings) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.enableAutoArchive,
        { archiveSettings }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const switchOnAutoArchive = (archiveSettings) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.switchOnAutoArchive,
        { archiveSettings }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export const switchOffAutoArchive = (archiveSettings) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.switchOffAutoArchive,
        { archiveSettings }
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};
